import {
  FETCH_PAYMENT_PROJECTS_REQUEST,
  FETCH_PAYMENT_PROJECTS_SUCCESS,
  FETCH_PAYMENT_PROJECTS_FAILURE,
  ADD_PAYMENT_PROJECT_REQUEST,
  ADD_PAYMENT_PROJECT_SUCCESS,
  ADD_PAYMENT_PROJECT_FAILURE,
  UPDATE_PAYMENT_PROJECTS_REQUEST,
  UPDATE_PAYMENT_PROJECTS_SUCCESS,
  UPDATE_PAYMENT_PROJECTS_FAILURE,
  CLEAR_PAYMENT_PROJECTS_ERROR,
} from "./paymentProjectActionTypes";

import api from "../../api/api";
import { toast } from "react-toastify";

// Mapping request types to their endpoints
/*const requestTypeRoutes = {
  "Payment Voucher": "/PaymentVoucher",
  "Salary Advance": "/SalaryAdvance",
  Loan: "/Loan",
};*/

// Utility function to handle errors
const handleError = (error) => {
  if (error.response) {
    return error.response.data?.message || "An error occurred.";
  }
  if (error.request) {
    return "No response received from the server. Please try again later.";
  }
  return error.message || "An unknown error occurred.";
};

// Action Creators
//
// Fetch Request Routes
export const fetchPaymentProjects = () => async (dispatch) => {
  dispatch({ type: FETCH_PAYMENT_PROJECTS_REQUEST });

  try {
    const response = await api.get("/RequestSetting/projects");
    // Log the response data
    console.log("Fetched Payment Projects:", response.data);
    dispatch({ type: FETCH_PAYMENT_PROJECTS_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage = handleError(error);
    dispatch({ type: FETCH_PAYMENT_PROJECTS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
  }
};

//export const addProject = () => { };

// Define and export a function for creating a role
export const addProject = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: ADD_PAYMENT_PROJECT_REQUEST });

    try {
      const response = await api.post("/RequestSetting/project", projectData);

      dispatch({ type: ADD_PAYMENT_PROJECT_SUCCESS, payload: response.data });
      // Display toast notification upon successful creation of a project
      toast.success("Project created successfully");
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          dispatch({
            type: ADD_PAYMENT_PROJECT_FAILURE,
            payload: "Invalid data. Please check your input fields.",
          });
          toast.error(
            "Project could not be created due to invalid inputs. Please try again",
          );
        } else if (error.response.status === 500) {
          dispatch({
            type: ADD_PAYMENT_PROJECT_FAILURE,
            payload:
              "Our server seems to be having issues. Please try again later.",
          });
          toast.error("Project could not be created. Please try again");
        } else {
          dispatch({
            type: ADD_PAYMENT_PROJECT_FAILURE,
            payload: "An unknown error occurred. Please try again soon.",
          });
          toast.error("Project could not be created. Please try again");
        }
      } else if (error.request) {
        // The request was made but no response was received
        dispatch({
          type: ADD_PAYMENT_PROJECT_FAILURE,
          payload:
            "No response was received from the server. Please try again later.",
        });
      } else {
        // Something happened in setting up the request that triggered an error
        dispatch({
          type: ADD_PAYMENT_PROJECT_FAILURE,
          payload:
            "An error occurred while setting up the request. Please try again later.",
        });
      }
    }
  };
};

// Define and export a function for updating a project
export const updatePaymentProject = (
  paymentProjectId,
  updatedPaymentProjectData,
) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_PAYMENT_PROJECTS_REQUEST });

    try {
      const response = await api.put(
        `/RequestSetting/project/${paymentProjectId}`,
        updatedPaymentProjectData,
      );

      dispatch({
        type: UPDATE_PAYMENT_PROJECTS_SUCCESS,
        payload: response.data,
      });
      toast.success("Project updated successfully");
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          dispatch({
            type: UPDATE_PAYMENT_PROJECTS_FAILURE,
            payload: "Invalid data. Please check your input fields.",
          });
          toast.error("Project update failed. Please try again.");
        } else if (error.response.status === 404) {
          dispatch({
            type: UPDATE_PAYMENT_PROJECTS_FAILURE,
            payload: "Role not found. Please try again",
          });
          toast.error("The project you are trying to update does not exist.");
        } else if (error.response.status === 500) {
          dispatch({
            type: UPDATE_PAYMENT_PROJECTS_FAILURE,
            payload:
              "Our server seems to be having issues. Please try again later.",
          });
          toast.error("Project update failed. Please try again later.");
        } else {
          dispatch({
            type: UPDATE_PAYMENT_PROJECTS_FAILURE,
            payload: "An unknown error occurred. Please try again soon",
          });
          toast.error("Project update failed. Please try again.");
        }
      } else if (error.request) {
        dispatch({
          type: UPDATE_PAYMENT_PROJECTS_FAILURE,
          payload:
            "No response was received from the server. Please try again later.",
        });
      } else {
        dispatch({
          type: UPDATE_PAYMENT_PROJECTS_FAILURE,
          payload:
            "An error occurred while setting up the request. Please try again later.",
        });
      }
    }
  };
};
